import MarqueeRow from "@/components/MarqueeRow";
import { proxied } from "@/lib/api";

const AvatarCard = ({ t }) => {
  const Wrap = t.link ? "a" : "div";
  const props = t.link ? { href: t.link, target: "_blank", rel: "noreferrer" } : {};
  return (
    <Wrap
      {...props}
      data-testid={`testimonial-${t.id}`}
      className="flex-shrink-0 w-[170px] sm:w-[190px] md:w-[210px] rounded-2xl overflow-hidden bg-[#1A1412] text-white border border-[#D4AF37]/15 block"
    >
      <div className="aspect-[4/5] overflow-hidden bg-[#241a17]">
        <img
          src={proxied(t.image)}
          alt={t.name}
          loading="lazy"
          draggable={false}
          onError={(e) => {
            e.currentTarget.style.opacity = "0.4";
          }}
          className="w-full h-full object-cover object-top pointer-events-none"
        />
      </div>
      <div className="p-3 md:p-4 text-center bg-gradient-to-b from-[#3a2418] to-[#1A1412]">
        <div className="font-serif text-sm md:text-base leading-tight text-white">{t.name}</div>
        {t.role && (
          <div className="text-[9px] tracking-[0.2em] uppercase mt-1 text-[#D4AF37] line-clamp-2 leading-relaxed">
            {t.role}
          </div>
        )}
      </div>
    </Wrap>
  );
};

const TrustedBy = ({ items = [], settings = {} }) => {
  if (!items.length) return null;
  const half = Math.ceil(items.length / 2);
  const row1 = items.slice(0, half);
  const row2 = items.slice(half);

  return (
    <section id="trusted" className="bg-[#FAF6F0] py-14 md:py-24">
      <div className="max-w-7xl mx-auto px-5 md:px-12 mb-10 md:mb-14 text-center">
        <div className="text-[#C89838] text-[10px] md:text-xs tracking-[0.4em] md:tracking-[0.5em] uppercase mb-3">
          {settings.trusted_kicker || "Seekers Worldwide"}
        </div>
        <h2 className="font-serif text-3xl md:text-6xl tracking-tight text-[#2D2825] leading-tight">{settings.trusted_title || "Trusted by Seekers Worldwide"}</h2>
        <p className="mt-4 text-[#5C544F] max-w-2xl mx-auto text-xs md:text-sm px-4">
          {settings.trusted_subtitle || "From spiritual practitioners to professionals and leaders, Rudralife serves a diverse global community."}
        </p>
        <div className="h-[2px] w-16 bg-[#D4AF37] mt-5 mx-auto" />
      </div>

      <div className="space-y-4 md:space-y-5">
        <MarqueeRow direction="left" speed={35} gap={16} noPause>
          {row1.map((t) => <AvatarCard key={`t1-${t.id}`} t={t} />)}
        </MarqueeRow>
        {row2.length > 0 && (
          <MarqueeRow direction="right" speed={35} gap={16} noPause>
            {row2.map((t) => <AvatarCard key={`t2-${t.id}`} t={t} />)}
          </MarqueeRow>
        )}
      </div>
    </section>
  );
};

export default TrustedBy;
